import Vue from 'vue'
import App from './App.vue'
import 'style/reset.less';
import 'style/base.less';
import 'style/mt.less';
import './main.less';

import 'view-design/dist/styles/iview.css';
import ViewUI from 'view-design';
Vue.use(ViewUI);

import mixin from 'utils/mixin';
Vue.mixin({
    methods: {
        ...mixin,
    }
});

Vue.config.productionTip = false

new Vue({
    el: '#app',
    render: h => h(App)
});
